import { LOCALES, ROUTES, rememberLocale, useLocale, type Locale } from '../i18n/locale';
import { SITE, translateHash } from '../content/site';

const SHORT: Record<Locale, string> = { 'es-CO': 'ES', en: 'EN' };

/** Restrained ES | EN switch: same page in the other language, same section, choice remembered. */
export function LanguageSwitch({ className }: { className?: string }) {
  const { locale, page } = useLocale(); const copy = SITE[locale].language;
  return (
    <nav className={`lang${className ? ` ${className}` : ''}`} aria-label={copy.label}>
      {LOCALES.map((target, index) => (
        <span key={target} className="lang__item">
          {index > 0 && <span className="lang__sep" aria-hidden="true">|</span>}
          {target === locale
            ? <span className="lang__current" aria-current="true" lang={target}>{SHORT[target]}<span className="visually-hidden"> {copy.current}</span></span>
            : (
              <a className="lang__link" href={ROUTES[page][target]} hrefLang={target} lang={target}
                onClick={event => { event.preventDefault(); rememberLocale(target); window.location.href = ROUTES[page][target] + translateHash(window.location.hash, target); }}>
                {SHORT[target]}<span className="visually-hidden"> {copy.switchTo}</span>
              </a>
            )}
        </span>
      ))}
    </nav>
  );
}
